import { render, staticRenderFns } from "./members.vue?vue&type=template&id=252245aa&scoped=true&"
import script from "./members.vue?vue&type=script&lang=js&"
export * from "./members.vue?vue&type=script&lang=js&"
import style0 from "./members.vue?vue&type=style&index=0&id=252245aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252245aa",
  null
  
)

export default component.exports